import { render } from "./room_scroll.vue?vue&type=template&id=afd935e6"
import script from "./room_scroll.vue?vue&type=script&lang=js"
export * from "./room_scroll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__